import React, { useState, useMemo } from "react";
import { useSociety } from "../context/SocietyContext";
import { addMember, removeMember } from "../../../api/societyRequest";
import "./members.css";
import SocietySideNav from "../navBarSocietyDashbard/navBarSocietyDashbard";

// Core Council posts
const CORE_COUNCIL_POSTS = [
  "President",
  "Vice President",
  "Director",
  "General Secretary",
  "Joint Secretary",
  "Treasurer",
  "Joint Treasurer",
];

// Role priority (STRICT ORDER)
const ROLE_PRIORITY = {
  CORE_COUNCIL: 1,
  HEAD: 2,
  CO_HEAD: 3,
  MEMBER: 4,
};

// Default avatar
const DEFAULT_AVATAR = "/images/user.png";

const Members = () => {
  const { members, setMembers, myRole } = useSociety();

  const [email, setEmail] = useState("");
  const [role, setRole] = useState("MEMBER");
  const [post, setPost] = useState("");
  const [rollNumber, setRollNumber] = useState("");

  const canManage = myRole === "CORE_COUNCIL" || myRole === "HEAD";

  // 🔥 SORT FIRST, NUMBER LATER
  const sortedMembers = useMemo(() => {
    return [...members].sort(
      (a, b) => ROLE_PRIORITY[a.role] - ROLE_PRIORITY[b.role]
    );
  }, [members]);

  const handleAdd = async () => {
    if (!email.trim() || !rollNumber.trim()) {
      alert("Email and Roll Number are required");
      return;
    }

    if (role === "CORE_COUNCIL" && !post) {
      alert("Core Council position is required");
      return;
    }

    try {
      const res = await addMember({
        email,
        role,
        rollNumber,
        post: role === "CORE_COUNCIL" ? post : undefined,
      });

      const newMember = res.data.member ?? res.data;
      setMembers((prev) => [...prev, newMember]);

      setEmail("");
      setRollNumber("");
      setRole("MEMBER");
      setPost("");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to add member");
    }
  };

  const handleRemove = async (id) => {
    if (!window.confirm("Remove this member?")) return;

    try {
      await removeMember(id);
      setMembers((prev) => prev.filter((m) => m._id !== id));
    } catch {
      alert("Failed to remove member");
    }
  };

  const academicYear = members[0]?.academicYear ?? "—";

  return (
    <div className="society-page">
      <SocietySideNav />

      <h1 className="page-title">
        Society Members {academicYear}
      </h1>

      {/* ADD MEMBER */}
      {canManage && (
        <div className="member-add">
          <input
            type="email"
            placeholder="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            placeholder="Roll Number"
            value={rollNumber}
            onChange={(e) => setRollNumber(e.target.value)}
          />

          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="MEMBER">Member</option>
            <option value="CO_HEAD">Co-Head</option>
            <option value="HEAD">Head</option>
            <option value="CORE_COUNCIL">Core Council</option>
          </select>

          {role === "CORE_COUNCIL" && (
            <select value={post} onChange={(e) => setPost(e.target.value)}>
              <option value="">Select Core Council Position</option>
              {CORE_COUNCIL_POSTS.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          )}

          <button onClick={handleAdd}>Add Member</button>
        </div>
      )}

      {/* MEMBER LIST */}
      <div className="member-list">
        {sortedMembers.map((m, index) => (
          <div key={m._id} className="member-row">

            {/* SERIAL NUMBER */}
            <div className="member-index">
              {index + 1}
            </div>

            {/* PROFILE PHOTO */}
            <img
              className="member-avatar"
              src={m.user?.profilePicUrl || DEFAULT_AVATAR}
              alt={m.user?.firstname || "user"}
            />

            {/* DETAILS */}
            <div className="member-info">
              <div className="member-name">
                {m.user?.firstname} {m.user?.lastname}
              </div>

              {m.role === "CORE_COUNCIL" ? (
                <div className="member-role core">
                  <span className="label">Position:</span> {m.post}
                </div>
              ) : (
                <div className="member-role">
                  <span className="label">Role:</span> {m.role}
                </div>
              )}
               <span className="label">{m.rollNumber}</span> 

            </div>

            {/* REMOVE */}
            {canManage && (
              <button
                className="danger"
                onClick={() => handleRemove(m._id)}
              >
                Remove
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Members;
